import { Sparkles, Twitter, Instagram, Youtube, Mail, Globe } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16" style={{ background: "hsl(var(--foreground))", color: "hsl(var(--background))" }}>
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 sm:gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 rounded-2xl flex items-center justify-center" style={{ background: "var(--gradient-hero)" }}>
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="text-2xl font-black" style={{ color: "hsl(var(--background))" }}>KelasAI</span>
            </div>
            <p className="text-sm font-medium leading-relaxed mb-4" style={{ color: "hsl(var(--background) / 0.6)" }}>
              {t("footer.tagline")}
            </p>
            <div className="flex gap-3">
              {[Twitter, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-xl flex items-center justify-center transition-all hover:opacity-100 opacity-60" style={{ background: "hsl(var(--background) / 0.1)" }}>
                  <Icon className="w-4 h-4" style={{ color: "hsl(var(--background))" }} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-extrabold mb-4 text-sm" style={{ color: "hsl(var(--background))" }}>{t("footer.product")}</h3>
            <ul className="flex flex-row flex-wrap md:flex-col gap-x-4 gap-y-2 md:gap-3">
              {[
                { label: t("footer.features"), to: "/fonctionnalites" },
                { label: t("footer.pricing"), to: "/tarifs" },
                { label: t("footer.school"), to: "/tarifs?contact=school" },
                { label: t("footer.roadmap"), to: "#" },
                { label: t("footer.changelog"), to: "#" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm font-semibold transition-opacity hover:opacity-100 opacity-60" style={{ color: "hsl(var(--background))" }}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-extrabold mb-4 text-sm" style={{ color: "hsl(var(--background))" }}>{t("footer.resources")}</h3>
            <ul className="flex flex-row flex-wrap md:flex-col gap-x-4 gap-y-2 md:gap-3">
              {[
                { label: t("footer.helpCenter"), to: "/centre-aide" },
                { label: t("footer.blog"), to: "#" },
                { label: t("footer.guides"), to: "/guide-apprentissage" },
                { label: t("footer.community"), to: "#" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm font-semibold transition-opacity hover:opacity-100 opacity-60" style={{ color: "hsl(var(--background))" }}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-extrabold mb-4 text-sm" style={{ color: "hsl(var(--background))" }}>{t("footer.contact")}</h3>
            <ul className="flex flex-row flex-wrap md:flex-col gap-x-4 gap-y-2 md:gap-3 mb-6">
              <li>
                <a href="mailto:kelasai@nicktech.io" className="flex items-center gap-2 text-sm font-semibold transition-opacity hover:opacity-100 opacity-60" style={{ color: "hsl(var(--background))" }}>
                  <Mail className="w-4 h-4" /> kelasai@nicktech.io
                </a>
              </li>
              <li>
                <a href="https://nick-tech.org" className="flex items-center gap-2 text-sm font-semibold transition-opacity hover:opacity-100 opacity-60" style={{ color: "hsl(var(--background))" }}>
                  <Globe className="w-4 h-4" /> nick-tech.org
                </a>
              </li>
            </ul>
            <h3 className="font-extrabold mb-3 text-sm" style={{ color: "hsl(var(--background))" }}>{t("footer.newsletter")}</h3>
            <div className="flex gap-2">
              <input type="email" placeholder={t("footer.emailPlaceholder")} className="flex-1 px-3 py-2 rounded-xl text-xs font-semibold outline-none" style={{ background: "hsl(var(--background) / 0.1)", border: "1px solid hsl(var(--background) / 0.15)", color: "hsl(var(--background))" }} />
              <button className="px-3 py-2 rounded-xl text-xs font-black text-white flex-shrink-0" style={{ background: "var(--gradient-hero)" }}>OK</button>
            </div>
          </div>
        </div>

        <hr style={{ borderColor: "hsl(var(--background) / 0.1)" }} />
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-sm font-medium opacity-40" style={{ color: "hsl(var(--background))" }}>
            © {currentYear} KelasAI. {t("footer.rights")}
          </p>
          <div className="flex flex-wrap gap-3 md:gap-6">
            <Link to="/confidentialite" className="text-xs font-semibold transition-opacity hover:opacity-80 opacity-40" style={{ color: "hsl(var(--background))" }}>{t("footer.privacy")}</Link>
            <Link to="/conditions" className="text-xs font-semibold transition-opacity hover:opacity-80 opacity-40" style={{ color: "hsl(var(--background))" }}>{t("footer.terms")}</Link>
            <a href="#" className="text-xs font-semibold transition-opacity hover:opacity-80 opacity-40" style={{ color: "hsl(var(--background))" }}>{t("footer.cookies")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
